// // src/pages/components/TaskFilters.tsx
// import React, { useState } from 'react';
// import { TaskFilters } from '../api/tasks';

// interface TaskFiltersProps {
//   filters: TaskFilters;
//   onFilterChange: (filters: Partial<TaskFilters>) => void;
// }

// function TaskFiltersComponent({ filters, onFilterChange }: TaskFiltersProps) {
//   const [isExpanded, setIsExpanded] = useState(false);
//   const [localFilters, setLocalFilters] = useState({
//     status: filters.status || '',
//     priority: filters.priority || '',
//     assigned_to: filters.assigned_to || '',
//     search: filters.search || '',
//     include_closed: filters.include_closed || false,
//   });

//   const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
//     const { name, value, type } = e.target;
//     const checked = (e.target as HTMLInputElement).checked;
//     setLocalFilters({
//       ...localFilters,
//       [name]: type === 'checkbox' ? checked : value,
//     });
//   };

//   const handleApply = () => {
//     const appliedFilters: Partial<TaskFilters> = {};
//     if (localFilters.status) appliedFilters.status = localFilters.status;
//     if (localFilters.priority) appliedFilters.priority = localFilters.priority;
//     if (localFilters.assigned_to) appliedFilters.assigned_to = localFilters.assigned_to;
//     if (localFilters.search) appliedFilters.search = localFilters.search;
//     appliedFilters.include_closed = localFilters.include_closed;
//     onFilterChange(appliedFilters);
//   };

//   const handleReset = () => {
//     setLocalFilters({
//       status: '',
//       priority: '',
//       assigned_to: '',
//       search: '',
//       include_closed: false,
//     });
//     onFilterChange({});
//   };

//   return (
//     <div className="task-filters">
//       <div className="filters-header" onClick={() => setIsExpanded(!isExpanded)}>
//         <span>🔍 Filters</span>
//         <span>{isExpanded ? '▲' : '▼'}</span>
//       </div>
      
//       {isExpanded && (
//         <div className="filters-body">
//           <div className="filter-row">
//             <div className="filter-group">
//               <label>Status</label>
//               <select name="status" value={localFilters.status} onChange={handleChange}>
//                 <option value="">All</option>
//                 <option value="TODO">Todo</option>
//                 <option value="IN_PROGRESS">In Progress</option>
//                 <option value="IN_REVIEW">In Review</option>
//                 <option value="BLOCKED">Blocked</option>
//                 <option value="DONE">Done</option>
//                 <option value="CANCELLED">Cancelled</option>
//               </select>
//             </div>

//             <div className="filter-group">
//               <label>Priority</label>
//               <select name="priority" value={localFilters.priority} onChange={handleChange}>
//                 <option value="">All</option>
//                 <option value="LOW">Low</option>
//                 <option value="MEDIUM">Medium</option>
//                 <option value="HIGH">High</option>
//                 <option value="URGENT">Urgent</option>
//               </select>
//             </div>

//             <div className="filter-group">
//               <label>Assigned To (User ID)</label>
//               <input
//                 type="text"
//                 name="assigned_to"
//                 value={localFilters.assigned_to}
//                 onChange={handleChange}
//                 placeholder="User ID"
//               />
//             </div>
//           </div>

//           <div className="filter-row">
//             <div className="filter-group">
//               <label>Search</label>
//               <input
//                 type="text"
//                 name="search"
//                 value={localFilters.search}
//                 onChange={handleChange}
//                 placeholder="Search title or description"
//               />
//             </div>

//             <div className="filter-group checkbox">
//               <label>
//                 <input
//                   type="checkbox"
//                   name="include_closed"
//                   checked={localFilters.include_closed}
//                   onChange={handleChange}
//                 />
//                 Include Closed Tasks
//               </label>
//             </div>
//           </div>

//           <div className="filter-actions">
//             <button className="btn-secondary" onClick={handleReset}>Reset</button>
//             <button className="btn-primary" onClick={handleApply}>Apply Filters</button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default TaskFiltersComponent;

// src/pages/components/TaskFilters.tsx
import React, { useState } from 'react';
import { TaskFilters } from '../api/tasks';

interface TaskFiltersProps {
  filters: TaskFilters;
  onFilterChange: (filters: Partial<TaskFilters>) => void;
}

function TaskFiltersComponent({ filters, onFilterChange }: TaskFiltersProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [localFilters, setLocalFilters] = useState({
    status: filters.status || '',
    priority: filters.priority || '',
    assigned_to: filters.assigned_to || '',
    search: filters.search || '',
    include_closed: filters.include_closed || false,
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target;
    const checked = (e.target as HTMLInputElement).checked;
    setLocalFilters({
      ...localFilters,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  const handleApply = () => {
    const appliedFilters: Partial<TaskFilters> = {};
    if (localFilters.status) appliedFilters.status = localFilters.status;
    if (localFilters.priority) appliedFilters.priority = localFilters.priority;
    if (localFilters.assigned_to) appliedFilters.assigned_to = localFilters.assigned_to;
    if (localFilters.search) appliedFilters.search = localFilters.search;
    appliedFilters.include_closed = localFilters.include_closed;
    onFilterChange(appliedFilters);
  };

  const handleReset = () => {
    setLocalFilters({
      status: '',
      priority: '',
      assigned_to: '',
      search: '',
      include_closed: false,
    });
    onFilterChange({});
  };

  const activeFiltersCount = [localFilters.status, localFilters.priority, localFilters.assigned_to, localFilters.search].filter(Boolean).length;

  return (
    <div className="bg-white rounded-xl shadow-md mb-6 overflow-hidden">
      <div 
        className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray-50 transition-colors"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center">
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
            </svg>
          </div>
          <span className="font-semibold text-gray-700">Filters</span>
          {activeFiltersCount > 0 && (
            <span className="px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full font-medium">
              {activeFiltersCount} active
            </span>
          )}
        </div>
        <div className="flex items-center gap-2">
          <svg className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      
      {isExpanded && (
        <div className="border-t border-gray-100 p-5 space-y-5 bg-gray-50/50">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
              <select 
                name="status" 
                value={localFilters.status} 
                onChange={handleChange}
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                <option value="">All Status</option>
                <option value="TODO">📋 To Do</option>
                <option value="IN_PROGRESS">🔄 In Progress</option>
                <option value="IN_REVIEW">👀 In Review</option>
                <option value="BLOCKED">🚫 Blocked</option>
                <option value="DONE">✅ Done</option>
                <option value="CANCELLED">❌ Cancelled</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Priority</label>
              <select 
                name="priority" 
                value={localFilters.priority} 
                onChange={handleChange}
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                <option value="">All Priority</option>
                <option value="LOW">🟢 Low</option>
                <option value="MEDIUM">🟡 Medium</option>
                <option value="HIGH">🟠 High</option>
                <option value="URGENT">🔴 Urgent</option>
              </select>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Assigned To</label>
              <input
                type="text"
                name="assigned_to"
                value={localFilters.assigned_to}
                onChange={handleChange}
                placeholder="Enter user ID"
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Search</label>
              <input
                type="text"
                name="search"
                value={localFilters.search}
                onChange={handleChange}
                placeholder="Title or description..."
                className="w-full px-3 py-2 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              />
            </div>
          </div>

          <div className="flex justify-between items-center pt-2">
            <label className="flex items-center gap-2 cursor-pointer group">
              <input
                type="checkbox"
                name="include_closed"
                checked={localFilters.include_closed}
                onChange={handleChange}
                className="w-4 h-4 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
              />
              <span className="text-sm text-gray-700 group-hover:text-gray-900 transition-colors">
                Include Closed Tasks
              </span>
            </label>
            
            <div className="flex gap-3">
              <button 
                onClick={handleReset}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-100 transition-all duration-200 font-medium"
              >
                Reset
              </button>
              <button 
                onClick={handleApply}
                className="px-5 py-2 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 font-medium shadow-sm hover:shadow-md"
              >
                Apply Filters
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default TaskFiltersComponent;